import { borderRadius } from '@moderneinc/design-system-tokens';
import { Box } from '@mui/material';
import type { FunctionComponent } from 'react';

import {
  BRANDING_LOGO_COLLAPSED_SIZE,
  BRANDING_LOGO_SIZE
} from '../../../constants/general';
import type { ModerneTenantConfiguration } from '../../../contexts/config.context';
import { BrandingImage } from '../../branding/branding-image.component';

type CustomerBrandingProps = {
  config?: ModerneTenantConfiguration;
  collapsed?: boolean;
  align?: 'center' | 'start' | 'auto';
};

export const CustomerBranding: FunctionComponent<CustomerBrandingProps> = ({
  config = {},
  collapsed = false,
  align = 'center'
}) => {
  if (!config?.brandingIcon) {
    return null;
  }

  const size = collapsed ? BRANDING_LOGO_COLLAPSED_SIZE : BRANDING_LOGO_SIZE;

  return (
    <Box
      sx={{
        alignSelf: align,
        display: 'flex',
        // Rounds the few brands whose mark ships on an opaque container.
        overflow: 'hidden',
        borderRadius: `${borderRadius.xS}px`,
        // NOTE: also centers in a block parent; alignSelf only applies in a flex one.
        mx: align === 'center' ? 'auto' : 0,
        height: size,
        width: size
      }}
    >
      {/* Fill the slot: marks are cropped differently per tenant, so their
          intrinsic size must not decide how big the logo renders. */}
      <BrandingImage
        src={config.brandingIcon}
        darkSrc={config.brandingIconDark}
        alt={config.name}
        style={{
          display: 'block',
          height: '100%',
          width: '100%',
          objectFit: 'contain'
        }}
      />
    </Box>
  );
};
